<template>
    <div>
        <div class="recommend" v-for="(c,i) in recommends" :key="i" @click="toDetail(c)">
            <div class="top-label" flex="cross:center main:center">{{$lang.get().recommendation}}</div>
            <div class="info" flex="cross:center">
                <div class="avatar f0">
                    <img :src="$util.img(c.logo)" />
                </div>
                <div class="name">{{$lang.getLang() == 'cn' ? c.name : c.name_en}}</div>
            </div>
            <div class="intro">{{emoveHtmlTags($lang.getLang() == 'cn' ? c.intro : c.intro_en)}}</div>
            <div class="location" flex="cross:center">
                <img src="@/assets/image2/map.png" />
                <div class="text">{{c.region_name}}</div>
            </div>
            <div class="labels" flex="">
                <div class="label" flex="cross:center main:center" v-if="j < 3" v-for="(p,j) in c.products" :key="j">{{$lang.getLang() == 'cn' ? p.name : p.name_en}}</div>
            </div>
            <div class="re-products" flex="main:justify">
                <div class="product-image f0" v-if="j < 2" v-for="(p,j) in c.products" :key="j">
                    <img :src="$util.img(JSON.parse(p.images)[0])" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            recommends: []
        }
    },
    mounted(){
        this.getRecommnendFactory()
    },
    methods: {
        toDetail(row){
            window.location.href = `/factory/detail?id=${row.id}`
        },
        emoveHtmlTags(text) {
            return text.replace(/<[^>]*>/g, '');
        },
        async getRecommnendFactory(){
            let res = await this.$api.rApi('factory/lists', {
                pageSize: 3,
                is_recommend: 1
            })
            if(res.status == 1){
                this.recommends = res.data.data
            }
        },
    }
}
</script>

<style lang="scss" scoped>

            .recommend{
                width: 345px;
                background: #FFFFFF;
                box-shadow: 0px 10px 20px 1px rgba(0,0,0,0.05);
                border-radius: 10px 10px 10px 10px;
                margin-top: 16px;
                padding-bottom: 20px;
                position: relative;
                cursor: pointer;
                .top-label{
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 116px;
                    height: 26px;
                    background: #E3E3E3;
                    border-radius: 0px 10px 0px 20px;
                    font-family: Arial, Arial;
                    font-weight: 400;
                    font-size: 12px;
                    color: #333333;
                }
                .info{
                    padding: 39px 27px 0 27px;
                    .avatar{
                        img{
                            width: 39px;
                            height: 39px;
                            border-radius: 20px;
                        }
                    }
                    .name{
                        padding-left: 10px;
                        font-family: Arial, Arial;
                        font-weight: bold;
                        font-size: 18px;
                        color: #000000;
                    }
                }
                .intro{
                    font-family: Arial, Arial;
                    font-weight: 400;
                    font-size: 12px;
                    color: #000000;
                    padding: 12px 27px;
                }
                .location{
                    padding: 0 27px;
                    img{
                        width:11.12px;
                        height: 13.9px;
                        margin-right: 6px;
                    }
                    .text{
                        font-family: Arial, Arial;
                        font-weight: 400;
                        font-size: 12px;
                        color: #216347;
                    }
                }
                .labels{
                    flex-wrap: wrap;
                    padding: 12px 0 0 27px;
                    .label{
                        height: 24px;
                        border-radius: 50px 50px 50px 50px;
                        border: 1px solid #216347;
                        padding: 0 10px;
                        font-family: Arial, Arial;
                        font-weight: 400;
                        font-size: 12px;
                        color: #216347;
                        margin-right: 10px;
                        margin-bottom: 10px;
                    }
                }
                .re-products{
                    padding: 0 27px;
                    .product-image{
                            border: 1px solid #E9E9E9;
                            width: 141px;
                            height: 141px;
                            border-radius: 10px;
                            overflow: hidden;
                        img{
                                transition: .3s;
                            width: 141px;
                            height: 141px;
                            box-sizing: border-box;
                            border-radius: 10px;
                            &:hover{
                                transition: .3s;
                                width: 151px;
                                height: 151px;
                                margin-top: -5px;
                                margin-left: -5px;
                            }
                        }
                    }
                }
            }
</style>


// WEBPACK FOOTER //
// src/components/RecommendFactory.vue